import { Container } from 'pixi.js';
import { PitService } from "../../entity/pit/PitService";
import { Pit } from "../../entity/pit/Pit";

export class PitPlaceholder {

    constructor() {
        this.isStarted = false;
        this.pit = {};
    }

    getStatement() {
        return this.pit;
    }

    start(position) {
        this.isStarted = true;
        this.startPosition = position;
    }

    stop() {
        this.clearPit();
        this.isStarted = false;
    }

    destroy() {
        this.stop();
    }

    move(position) {
        if (this.isStarted) {
            this.drawPit({
                xo: this.startPosition.x,
                yo: this.startPosition.y,
                xd: position.x,
                yd: position.y,
            });
        }
    }

    drawPit(dimensions) {

        this.clearPit();
        let container = new Container();
        container.position.x = dimensions.xo;
        container.position.y = dimensions.yo;

        let rectDimensions = {
            xo: 0,
            yo: 0,
            xd: dimensions.xd - dimensions.xo,
            yd: dimensions.yd - dimensions.yo,
        };
        const graphicItems = [PitService.createGraphicItem(rectDimensions)];
        const pit = new Pit({
            container,
            graphicItems,
            width: dimensions.xd - dimensions.xo,
            height: dimensions.yd - dimensions.yo,
        });
        pit.draw();
        this.pit = pit;
    }

    clearPit() {
        if (this.pit.destroy) this.pit.destroy();
        this.pit = {};
    }
}